import React, { useState, useEffect } from "react";

import "./sidebar.css";

const ImageShow = ({ images, time }) => {
  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const id = setTimeout(() => {
      setCurrentImage((currentImage + 1) % images.length);
    }, time);
    return () => {
      clearTimeout(id);
    };
  }, [currentImage]);

  return <img src={images[currentImage]} alt="foto"></img>;
};

export default ImageShow;



// WEBPACK FOOTER //
// ./src/components/UI/Sidebar/ImageShow.jsx